// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"c72b94c93384cbcfa632","5338":"84d9d2dd7d4f35078ff6"}[chunkId] + ".js";
};